export const services = {
  is: {
    title: "Þjónusta sem skilar árangri",
    description: "Við bjóðum upp á heildstæða þjónustu í stafrænni þróun. Frá hugmynd að fullkláruðu verkefni og áframhaldandi viðhaldi.",
    marketing: {
      title: "Markaðssetning",
      description: "Árangursríkar stafrænar markaðssetningaraðferðir sem auka sýnileika og skila árangri."
    },
    seo: {
      title: "Leitarvélabestun",
      description: "Bættu leitarvélabestun vefsíðunnar þinnar fyrir betri sýnileika í leitarvélum og auktu lífræna umferð."
    },
    analytics: {
      title: "Greiningar",
      description: "Fáðu gagnlegar upplýsingar úr gögnum og taktu upplýstar ákvarðanir byggðar á greiningum."
    },
    maintenance: {
      title: "Viðhald",
      description: "Viðvarandi stuðningur og viðhald til að halda vefsíðunni þinni öruggri og uppfærðri."
    }
  },
  en: {
    title: "Services that deliver results",
    description: "We offer comprehensive services in digital development. From concept to completed project and ongoing maintenance.",
    marketing: {
      title: "Marketing",
      description: "Effective digital marketing strategies that increase visibility and drive results."
    },
    seo: {
      title: "SEO",
      description: "Optimize your website for better visibility in search engines and increase organic traffic."
    },
    analytics: {
      title: "Analytics",
      description: "Gain valuable insights from data and make informed decisions based on analytics."
    },
    maintenance: {
      title: "Maintenance",
      description: "Ongoing support and maintenance to keep your website secure and up-to-date."
    }
  },
  es: {
    title: "Servicios que entregan resultados",
    description: "Ofrecemos servicios integrales en desarrollo digital. Desde el concepto hasta el proyecto terminado y mantenimiento continuo.",
    marketing: {
      title: "Marketing",
      description: "Estrategias efectivas de marketing digital que aumentan la visibilidad y generan resultados."
    },
    seo: {
      title: "SEO",
      description: "Optimice su sitio web para obtener mejor visibilidad en los motores de búsqueda y aumentar el tráfico orgánico."
    },
    analytics: {
      title: "Analítica",
      description: "Obtenga información valiosa de los datos y tome decisiones informadas basadas en análisis."
    },
    maintenance: {
      title: "Mantenimiento",
      description: "Soporte y mantenimiento continuos para mantener su sitio web seguro y actualizado."
    }
  },
  da: {
    title: "Tjenester der leverer resultater",
    description: "Vi tilbyder omfattende tjenester inden for digital udvikling. Fra koncept til færdigt projekt og løbende vedligeholdelse.",
    marketing: {
      title: "Marketing",
      description: "Effektive digitale markedsføringsstrategier, der øger synligheden og skaber resultater."
    },
    seo: {
      title: "SEO",
      description: "Optimer dit websted for bedre synlighed i søgemaskiner og øg den organiske trafik."
    },
    analytics: {
      title: "Analyse",
      description: "Få værdifuld indsigt fra data og træf informerede beslutninger baseret på analyser."
    },
    maintenance: {
      title: "Vedligeholdelse",
      description: "Løbende support og vedligeholdelse for at holde dit websted sikkert og opdateret."
    }
  }
};